import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './Layout';
import SalaryDashboard from './SalaryDashboard';
import EmployeeView from './EmployeeView';
import EmployeeDashboard from './EmployeeDashboard';
import EmployeeCenter from './EmployeeCenter';
import PaystubPage from './PaystubPage';
import EmployeeGratuity from './EmployeeGratuity';
import Payroll from './Payroll';
import SettingsPage from './SettingsPage';
import Login from './Login';
import AuthCallback from './AuthCallback';


const App = () => {
  const isAuthenticated = localStorage.getItem('authenticated') === 'true';

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/auth-callback" element={<AuthCallback />} />
        <Route path="/paystub/:employeeId" element={<PaystubPage />} />

        {isAuthenticated ? (
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/salary-dashboard" />} />
            <Route path="salary-dashboard" element={<SalaryDashboard />} />
            <Route path="employee-view" element={<EmployeeView />} />
            <Route path="employee-dashboard" element={<EmployeeDashboard />} />
            <Route path="/employee-center" element={<EmployeeCenter />} />
            <Route path="employee-gratuity" element={<EmployeeGratuity />} />
            <Route path="payroll" element={<Payroll />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
      </Routes>
    </BrowserRouter>
  );
};

export default App;
